<template>
  <div class="container">
    <div class="home_one-featured-wrapper bg_secondary round-10">
      <div class="row justify-content-center gx-xxl-6">
        <div
          class="col-lg-4 col-md-6"
          v-for="feature in features"
          :key="feature.id"
          data-aos="fade-up"
          data-aos-duration="1000"
          :data-aos-delay="feature.dataDelay"
        >
          <div class="featured-card">
            <span
              class="feature-icon d-flex flex-column justify-content-center align-items-center"
            >
              <img :src="feature.imageIcon" alt="Image" />
            </span>
            <h3 class="fs-20 text-white">
              {{ feature.title }}
            </h3>
            <p class="text-offwhite mb-0">
              {{ feature.desc }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "FeaturesContent",
  data() {
    return {
      features: [
        {
          id: 1,
          dataDelay: "100",
          imageIcon: require("../../assets/img/icons/mention.svg"),
          title: "Love Widgets",
          desc: "Transform your home screen into a romantic sanctuary with beautiful widgets that display your shared moments and love notes.",
        },
        {
          id: 2,
          dataDelay: "200",
          imageIcon: require("../../assets/img/icons/attachment.svg"),
          title: "Instant Sharing",
          desc: "Share photos, messages, and special moments instantly with your partner through seamless widget integration.",
        },
        {
          id: 3,
          dataDelay: "300",
          imageIcon: require("../../assets/img/icons/cube.svg"),
          title: "Anniversary Tracker",
          desc: "Never miss important dates with built-in anniversary countdowns and relationship milestone celebrations.",
        },
        {
          id: 4,
          dataDelay: "400",
          imageIcon: require("../../assets/img/icons/document.svg"),
          title: "Love Notes",
          desc: "Send surprise love notes that appear directly on your partner's home screen, creating magical moments throughout the day.",
        },
        {
          id: 5,
          dataDelay: "500",
          imageIcon: require("../../assets/img/icons/files.svg"),
          title: "Memory Gallery",
          desc: "Create a private gallery of your favorite couple moments that you can access and share through beautiful widgets.",
        },
        {
          id: 6,
          dataDelay: "600",
          imageIcon: require("../../assets/img/icons/mention.svg"),
          title: "Real-time Connection",
          desc: "Stay connected with your partner in real-time, no matter the distance, through live widget updates and notifications.",
        },
      ],
    };
  },
});
</script>

<style lang="scss" scoped>
.home_one-featured-wrapper {
  padding: 110px 50px 60px;
  .featured-card {
    margin-bottom: 52px;
    transition: var(--transition);
    .feature-icon {
      width: 65px;
      height: 65px;
      border-radius: 50%;
      border: 1px solid rgba(167, 97, 248, 0.1);
      margin-bottom: 20px;
    }
    h3 {
      margin-bottom: 11px;
      font-weight: 400;
    }
    p {
      padding-right: 35px;
    }
    &:hover {
      transform: translateY(-4px);
    }
  }
}

@media only screen and (max-width: 767px) {
  .home_one-featured-wrapper {
    padding: 50px 20px 10px;
  }
}

@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .home_one-featured-wrapper {
    padding: 110px 30px 60px;
    .featured-card {
      p {
        padding-right: 0;
      }
    }
  }
}

@media only screen and (min-width: 1400px) {
  .home_one-featured-wrapper {
    padding: 110px 110px 50px;
    .featured-card {
      p {
        width: calc(100% + 15px);
        padding-right: 0;
      }
    }
  }
}
</style>